import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { ConstantsService } from "../services/constants.service";
import { HttpClient } from '@angular/common/http';
import { VimeoService } from '../services/vimeo.service';
import { AdminService } from '../services/admin.service';
import { CacheService } from '../services/cache.service';
import { GetPaymentService } from '../services/get-payment.service';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerService } from '../services/spinner.service';
import { Title } from '@angular/platform-browser';

const B_CACKE_KEY = 'bookmarked_Cache'

@Component({
  selector: 'app-bookmarked',
  templateUrl: './bookmarked.component.html',
  styleUrls: ['./bookmarked.component.scss']
})
export class BookmarkedComponent implements OnInit {
  public Primemember = false;
  public videoItem: any = [];
  public thumbnail = null;
  public author = null;
  public location = null;
  public userName = null;
  public isLoading = true;
  public user = null;
  public sub: any;
  public isBookmarkEmpty = false;
  public limitreached = true
  public limitnotreached = true
  public skeltonArray = [];
  public isPrime: any;
  public hasLimitReached = false;
  name: any;
  startKey: any = null;
  login: boolean = false;
  showconfirmModal: boolean = false;
  public isRemoving = false;
  unBookmarkVideoName: any;
  constructor(
    private dataService: DataService,
    private urlConstants: UrlConstants,
    public constants: ConstantsService,
    public http: HttpClient,
    private vimeData: VimeoService,
    private adminservice: AdminService,
    private authenticate: CacheService,
    private router: Router,
    private get_payment: GetPaymentService,
    public dialog: MatDialog,
    private spinner: SpinnerService,
    private title: Title

  ) {
    var skelton = [
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,]
    this.skeltonArray = skelton;
  }
  load = async () => {
    this.get_payment.cast.subscribe(data => {
      let userDetails = data
      if (userDetails === null) {
        this.router.navigate(['/'])
      } else {
        this.isPrime = userDetails.isPrime
      }
    })
    this.onBookmarkLoad();


  }
  unbookmark = async () => {
    this.isRemoving = true;
    document.getElementById(this.unBookmarkVideoName).style.opacity = '50%'
    const params = [
      { param: '{object}', value: "bookmarks" },
    ];
    const bodyObj = {
      "userName": this.userName,
      "videoId": this.unBookmarkVideoName,
    }
    try {
      await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.deleteItem, params), JSON.stringify(bodyObj)).toPromise();
      this.showconfirmModal = false;
      this.isRemoving = false;
      document.getElementById(this.unBookmarkVideoName).style.display = 'none';
    } catch (e) {
      this.showconfirmModal = false;
      this.isRemoving = false;
    }
  }
  async init() {
    await this.load();
  }
  openFavWindow = (event) => {
    let videoid = event.target.name;
    this.videoItem = this.getFormattedObject(this.videoItem);
    let videosBeforeClickedVideo = []
    let ClickedVideo = [];
    let videosAfterClickedVideo = [];
    ClickedVideo = this.videoItem.filter(clickedVideo => clickedVideo.videoId === videoid);
    videosBeforeClickedVideo = this.videoItem.slice(0, this.videoItem.indexOf(ClickedVideo[0]))
    videosAfterClickedVideo = this.videoItem.slice(this.videoItem.indexOf(ClickedVideo[0]) + 1, this.videoItem.length)
    this.videoItem = [...ClickedVideo, ...videosAfterClickedVideo, ...videosBeforeClickedVideo];
    this.router.navigateByUrl('/Window', { state: { data: this.videoItem, map: false } })
  }
  changeVideoOrder = (videos, from, to) => {
    videos.splice(to, 0, videos.splice(from, 1)[0])
    return videos
  }
  ngOnInit(): void {
    this.openBookmarkAlert("bookmarklimit")
    let userDetails = this.adminservice.getSharedUserData()
    if (userDetails !== undefined) {
      this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - ${userDetails.given_name}'s ${this.constants.TITLE.bookmark}`);
      this.userName = userDetails.email;
      this.user = userDetails.name;
      this.init();
    }
    else {
      this.authcall()
    }

  }
  async authcall() {
    this.authenticate.getAuthUser()
      .then(async data => {
        let { email, given_name, login, userName } = data
        this.userName = email
        this.user = given_name
        this.name = userName
        this.login = login;
        this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - ${this.user}'s ${this.constants.TITLE.bookmark}`);
        await this.init();
        if (!login) {
          this.router.navigate(['/login'])
        }
        this.spinner.hide()
      })
      .catch((error) => {
        this.spinner.hide()
      })
  }
  Takemetoprime() {
    if (this.login) {
      this.router.navigate(['/pricing']);
    } else {
      this.router.navigate(['/signup']);
    }
  }
  openBookmarkAlert(event) {
    let value = event
    if (value === "primemember") {
      document.getElementById("bookmark-alert").style.display = "block";
    }
  }
  closeBookmarkAlert() {
    document.getElementById('bookmark-alert').style.display = "none";
    this.Primemember = false
  }

  async onBookmarkLoad() {
    this.isLoading = true;
    let bookmarkArrayList
    const params = [
      { param: '{actionName}', value: 'pagination' }
    ]
    const postdata = {
      "userName": this.userName,
      "LastEvaluatedKey": this.startKey !== null ? this.startKey : null,
    }
    try {
      bookmarkArrayList = await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata)

      bookmarkArrayList.subscribe(async data => {
        let { Items } = data.res;
        this.videoItem = [...this.videoItem, ...Items];
        this.isLoading = false;
        this.getLastEvekey(data, postdata);
        this.startKey = data['res'].LastEvaluatedKey
        if (this.videoItem.length >= 30 && !this.isPrime) {
          this.limitreached = false
          this.limitnotreached = true
        }
        else if (this.videoItem.length < 30 && !this.isPrime) {
          this.limitnotreached = false
          this.limitreached = true
        } else if (this.isPrime) {
          this.limitnotreached = true
          this.limitreached = true

        }
        if (this.videoItem !== undefined) {
          this.videoItem.forEach(async element => {
            var videoid = element.videoId
            if (element.thumbnail === undefined) {
              await this.vimeData.vimeoData(videoid)
                .then((data) => {
                  element.thumbnail = data['data']['data']['0']['sizes']['2'].link
                  const params = [
                    { param: '{object}', value: 'bookmarks' },
                  ];
                  const bodyObj = {
                    thumbnail: data['data']['data']['0']['sizes']['2'].link,
                    userName: this.userName,
                    videoId: videoid
                  }
                  this.dataService.postData(this.urlConstants.getUri(this.urlConstants.updateItem, params), JSON.stringify(bodyObj)).toPromise()
                })
                .catch((error) => {
                })
            }
          });
        }
        if (Object.keys(this.videoItem).length === 0) {
          this.isBookmarkEmpty = true;
        }
        this.isLoading = false;
      })
    } catch (e) {
      this.isLoading = false;
    }
  }
  getLastEvekey(data, postdata) {
    if (data['res'].LastEvaluatedKey !== null) {
      postdata.LastEvaluatedKey = data['res'].LastEvaluatedKey;
      this.startKey = postdata.LastEvaluatedKey;

    }
  }
  onClickCloseConfirmPopup() {
    this.showconfirmModal = false
  }

  onClickShowConfirmPopup(event) {
    this.showconfirmModal = true;
    this.unBookmarkVideoName = event.target.name;
  }
  getFormattedObject(video) {
    video.forEach(element => {
      if (element.url.includes('https://player.vimeo.com/video/')) {
        let url = element.url.split('https://player.vimeo.com/video/')[1]
        element['url1'] = url.split('/')[0];
        url.split('/')[1] === undefined ? element['url2'] = "" : element['url2'] = url.split('/')[1];
        element['cityLocation'] = element.location;
      }
      else {
        let url = element.url.split('/');
        element['url1'] = url[0];
        url[1] === undefined ?  element['url2'] = "" : element['url2'] = url[1];
        element['cityLocation'] = element.location;
      }
    });
    return video;
  }
}
